<p-toast (click)="onclick()" [baseZIndex]="5000" position="top-center" closable="false" [preventOpenDuplicates]="true">
</p-toast>
<p-confirmPopup></p-confirmPopup>
<div *ngIf="loading" class="premium-loader-wrapper">
    <div class="loader-content">
        <div class="glow-ring"></div>
        <div class="glow-ring inner"></div>
        <div class="app-icon">
            <i class="pi pi-box"></i>
        </div>
    </div>
    <div class="loading-text">Loading application...</div>
</div>
<router-outlet></router-outlet>